import React from 'react';
import { Box, Typography, Chip, Grid } from '@mui/material';
import PropTypes from 'prop-types';

const ProjectCard = ({ heading, customer, role, description, skills }) => {
  return (
    <Box
      sx={{
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px',
        backgroundColor: '#ffffff',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Typography variant="h6" color="primary" fontWeight="bold" gutterBottom>
        {heading}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        <strong>Customer:</strong> {customer}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        <strong>Role:</strong> {role}
      </Typography>
      <Typography variant="body1" color="text.primary" sx={{ marginBottom: '16px' }}>
        {description}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ marginBottom: '8px' }}>
        <strong>Skills:</strong>
      </Typography>
      <Grid container spacing={1}>
        {skills.map((skill, index) => (
          <Grid item key={index}>
            <Chip label={skill} color="primary" variant="outlined" />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

// PropTypes for type-checking
ProjectCard.propTypes = {
  heading: PropTypes.string.isRequired,
  customer: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  skills: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProjectCard;
